@if (!loading()) {
	@if (data(); as data) {
		<div class="aanwezigheid-matrix" [style]="gridStyle()">
			<div class="matrix-cell corner-cell"></div>

			@for (header of data.columnHeaders; track $index) {
				<div class="matrix-cell column-header-cell" [class]="data.columnClasses[$index]">
					<span>{{ header }}</span>
					@if (data.columnClasses[$index] === "voorlopig") {
						<app-icon name="trend" size="small" color="typography-2"></app-icon>
					}
				</div>
			}

			@for (row of data.cells; track $index; let rowIndex = $index) {
				<div class="matrix-cell row-header-cell">
					{{ data.rowHeaders[rowIndex] }}
				</div>

				@for (cell of row; track $index) {
					<div class="matrix-cell data-cell" [appTooltip]="cell.tooltip">
						<div class="cell-background" [class]="getCellClass(cell)"></div>
						<div class="cell-content">
							{{ getCellDisplayValue(cell) }}
							@if (!cell.disabled && cell.displayValue === undefined) {
								<span class="percentage-symbol">%</span>
							}
						</div>
					</div>
				}
			}
		</div>
	} @else {
		<div>De huidige selectie levert geen resultaten op.</div>
	}
} @else if (spinnerDelay | async) {
	<app-css-spinner></app-css-spinner>
}
